import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";

function Recommendation() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        const headers = {
          "Content-Type": "application/json",
          ...(authUser?.token && { Authorization: `Bearer ${authUser.token}` }),
        };

        const res = await fetch("http://localhost:5050/api/vulnerabilities/stats", { headers });
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        if (json.success) {
          setStats(json.stats);
        }
      } catch (err) {
        console.error("Error fetching final recommendation stats:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="text-center p-3">
        <Spinner color="danger" />
        <p className="text-muted">Loading recommendations...</p>
      </div>
    );
  }

  if (!stats) {
    return <p className="text-muted">No recommendation data available</p>;
  }


  const recommendations = [];

  if (stats.critical > 0) {
    recommendations.push(`Resolve ${stats.critical} critical vulnerabilities immediately (within 7 days).`);
  }
  if (stats.high > 0) {
    recommendations.push(`Address ${stats.high} high severity issues within 14 days.`);
  }
  if (stats.medium > 0) {
    recommendations.push(`Plan remediation for ${stats.medium} medium severity vulnerabilities in the next patch cycle.`);
  }
  if (stats.low > 0) {
    recommendations.push(`Monitor ${stats.low} low severity vulnerabilities and prioritize based on business impact.`);
  }

  if (stats.fixable > 0) {
    recommendations.push(`Apply available fixes for ${stats.fixable} vulnerabilities to reduce exposure quickly.`);
  }

  recommendations.push(`Average CVSS score is ${stats.avg_cvss}, with a maximum of ${stats.max_cvss}. Focus remediation on higher scoring vulnerabilities first.`);

  return (
    <div className="bg-white text-dark p-3 rounded shadow-sm mt-4" >
      <h5 className="mb-3 text-dark" style={{ backgroundColor: "#FFB380", border: "none", padding: "1rem 1.5rem", }}>Final Recommendations</h5>
      <ul>
        {recommendations.map((rec, idx) => (
          <li key={idx}>{rec}</li>
        ))}
      </ul>
    </div>
  );
}

export default Recommendation;
